import { selectOne } from 'vevet-dom';
import Bar from './Bar';
import { Component as ComponentClass } from '../../base/Component';
import { onResize } from '../../utils/listeners/onResize';
/**
 * Create custom scroll bar
 */
export class ScrollBar extends ComponentClass {
    _getDefaultProps() {
        return Object.assign(Object.assign({}, super._getDefaultProps()), { container: window, domParent: false, resizeDebounce: 16, isDraggable: true, shouldAutoSize: true, canAutoHide: true, minSize: 50, scrollBehavior: 'smooth' });
    }
    get prefix() {
        return `${this.app.prefix}scrollbar`;
    }
    /** Scroll container */
    get container() {
        return this._container;
    }
    /** Scrollable element */
    get scrollableElement() {
        const { container } = this;
        if (container instanceof Window) {
            return this.app.body;
        }
        if (container instanceof Element) {
            return container;
        }
        return container.container;
    }
    /**
     * The element where scrollbars will be appended
     */
    get domParent() {
        const { domParent } = this.props;
        if (domParent) {
            return domParent;
        }
        const { container } = this;
        if (container instanceof Window) {
            return this.app.body;
        }
        if (container instanceof Element) {
            return container;
        }
        return container.container;
    }
    constructor(initialProps, canInit = true) {
        super(initialProps, false);
        const { container } = this.props;
        // get container
        if (typeof container === 'string') {
            const element = selectOne(container);
            if (element) {
                this._container = element;
            }
            else {
                throw new Error('No scroll container');
            }
        }
        else {
            this._container = container;
        }
        // create bars
        const barProps = Object.assign(Object.assign({}, this.props), { container: this.container, domParent: this.domParent, prefix: this.prefix });
        this._xBar = new Bar(Object.assign(Object.assign({}, barProps), { direction: 'x' }));
        this._yBar = new Bar(Object.assign(Object.assign({}, barProps), { direction: 'y' }));
        // add classnames
        this.toggleClassName(this.scrollableElement, this.className('-parent'), true);
        // initialize the class
        if (canInit) {
            this.init();
        }
    }
    _init() {
        super._init();
        this._setEvents();
    }
    // Set Module Events
    _setEvents() {
        const { container, props } = this;
        // default resize handler
        const resizeHandler = onResize({
            onResize: () => this.resize(),
            element: [this._xBar.outer, this._yBar.outer],
            viewportTarget: 'any',
            hasBothEvents: true,
            resizeDebounce: props.resizeDebounce,
        });
        // resize for smoothscroll
        const smoothScrollResize = 'isSmoothScroll' in container
            ? container.addCallback('resize', () => resizeHandler.debounceResize(), { name: this.name })
            : undefined;
        this.addDestroyableAction(() => {
            resizeHandler.remove();
            smoothScrollResize === null || smoothScrollResize === void 0 ? void 0 : smoothScrollResize.remove();
        });
        // initial resize
        resizeHandler.resize();
    }
    _onPropsMutate() {
        super._onPropsMutate();
        this.resize();
    }
    /** Resize the scene */
    resize() {
        this._xBar.resize();
        this._yBar.resize();
    }
    /** Destroy the module */
    _destroy() {
        super._destroy();
        // destroy bars
        this._xBar.destroy();
        this._yBar.destroy();
    }
}
//# sourceMappingURL=index.js.map